import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-0fb9e8d0")

_pushScopeId("data-v-0fb9e8d0")
const _hoisted_1 = {
  key: 0,
  src: _imports_0,
  class: "w-4",
  alt: "up"
}
const _hoisted_2 = {
  key: 1,
  src: _imports_1,
  class: "w-4",
  alt: "down"
}
const _hoisted_3 = {
  key: 0,
  class: "select-search py-1 overflow-y-auto"
}
const _hoisted_4 = {
  key: 1,
  class: "select-search py-3 overflow-y-auto text-center text-gray-500"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Apa yang anda cari tidak")
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" ditemukan atau tidak ada ")
const _hoisted_8 = {
  key: 2,
  class: "select-search py-1 overflow-y-auto text-center text-xs text-gray-500"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: 
      `inline-block relative bottom-0 left-0 text-12px xxl:text-14px ${
        _ctx.noSpaceRight ? '' : 'mr-4'
      }`
    
  }, [
    _createVNode("div", {
      class: 
        `bg-white ${
          _ctx.isOpenSearch
            ? _ctx.noSpaceLeft
              ? 'right-search'
              : _ctx.noSpaceRight
              ? 'left-search'
              : 'rounded-t'
            : 'rounded'
        }
        ${
          _ctx.noSpaceLeft
            ? 'rounded-l-none right-search-border'
            : _ctx.noSpaceRight
            ? 'rounded-r-none'
            : ''
        }
        border ${
          _ctx.isError ? 'border-red-lp-800' : 'border-gray-lp-400'
        } text-black-lp-300 leading-tight px-3 py-2.5 xxl:py-2.5 pr-8 font-normal`
      
    }, [
      _createVNode("input", {
        type: "text",
        placeholder: _ctx.placeholder,
        onInput: _cache[1] || (_cache[1] = e => _ctx.onSearch(e.target.value)),
        value: _ctx.value,
        onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onOpenSearch && _ctx.onOpenSearch(...args))),
        onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onCloseSearch && _ctx.onCloseSearch(...args))),
        class: 
          `w-full truncate bg-none self-center align-middle focus:outline-none  ${_ctx.isDisabled &&
            'bg-white text-gray-lp-600 cursor-not-allowed'}`
        ,
        ref: "selectSearch",
        disabled: _ctx.isDisabled
      }, null, 42, ["placeholder", "value", "disabled"]),
      _createVNode("div", {
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.isClickChevron && _ctx.isClickChevron(...args))),
        class: 
          `${_ctx.isDisabled &&
            'cursor-not-allowed'} cursor-pointer absolute inset-y-0 right-0 flex items-center justify-center px-2`
        
      }, [
        (_ctx.isOpenSearch)
          ? (_openBlock(), _createBlock("img", _hoisted_1))
          : (_openBlock(), _createBlock("img", _hoisted_2))
      ], 2)
    ], 2),
    _withDirectives(_createVNode("div", {
      class: "w-full p-1 bg-white absolute rounded-b border border-t-0 border-gray-lp-400 rounded-b-md z-50",
      style: `${_ctx.noSpaceLeft && 'left:-1px'}`
    }, [
      (_ctx.dataSearch.length > _ctx.getAllData)
        ? (_openBlock(), _createBlock("ul", _hoisted_3, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataSearch, (item, index) => {
              return (_openBlock(), _createBlock("li", {
                key: index,
                onMousedown: () => _ctx.onChooseSearch(item.name, item.code, item),
                class: "max-w-full cursor-pointer py-2.5 hover:bg-gray-lp-700 z-50 p-3"
              }, _toDisplayString(item.name), 41, ["onMousedown"]))
            }), 128))
          ]))
        : (_ctx.notFound)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _hoisted_5,
              _hoisted_6,
              _hoisted_7
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_8))
    ], 4), [
      [_vShow, _ctx.isOpenSearch]
    ])
  ], 2))
})